import axios from 'axios'

export var loggedIn = false

export const API_BASE_URL = `https://${process.env.VUE_APP_BACKEND}`

const options = {
  baseURL: API_BASE_URL,
  headers: {
    'Access-Control-Allow-Origin': '*'
  }
}

// eslint-disable-next-line new-cap
const AXIOS = new axios.create(options)

export default AXIOS
